
























import {Component, Prop, Vue} from 'vue-property-decorator';
import {GlobalConstants} from '@/common/constants';
import appModule from '@/model/store/modules/app-module';

@Component
export default class LoadingDialog extends Vue {
  /** Props **/

  get text() {
    return {
      loading: GlobalConstants.TEXT.LOADING
    };
  }

  set isLoading(val: boolean) {}

  get isLoading() {
    return appModule.isLoading;
  }
}
